import React from "react";

interface Myprops {
    eventDate: any
}

interface myState {
    days: any,
    hours: any,
    minutes: any,
    seconds: any
}

export default class Flashdealtimer extends React.Component<Myprops, myState> {

    constructor(props: any) {
        super(props);
        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }   

    componentDidMount() {
        this.getTimeDifference(this.props.eventDate);
        setInterval(() => this.getTimeDifference(this.props.eventDate), 1000);
    }

    leadingZero(num: any) {
        return num < 10 && num > 0 ? "0" + num : num;
    }

    getTimeDifference(eventDate: any) {
        const time = Date.parse(eventDate) - Date.parse(new Date().toString());     
        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const seconds = Math.floor((time / 1000) % 60);
        this.setState({ days, hours, minutes, seconds });
    }

    render(): React.ReactNode {
        
        return (
            <>
                {/* Flash deal timer start */}

                <span>
                    {this.leadingZero(this.state.days)}{" "}
                    {this.state.days === 1 ? "Day" : "Days"}&nbsp;:&nbsp;
                    {this.leadingZero(this.state.hours)}{" "}
                    {this.state.hours === 1 ? "Hour" : "Hours"}&nbsp;:&nbsp;
                    {this.leadingZero(this.state.minutes)}{" "}
                    {this.state.minutes === 1 ? "minute" : "Minutes"}
                </span>

                {/* Flash deal timer over */}
            </>
        )
    }

}